import { plainToClass } from "class-transformer";
import { DateUpdatedSection } from "../../../../shared/components/date-updated-section/date-updated-section.view";
import { DoArraysOverlap, Unique } from "../../../../shared/scripts/array-functions";
import { IFilter } from "../../../../shared/scripts/filtering/filtering.entities";
import { GetSelectedDropdownValues, InitializeFilterDropdown } from "../../../../shared/scripts/filtering/filtering.utilities";
import { IStudyAppendixSiteFilterParent, StudyAppendixSiteFilterSection } from "../../../../shared/scripts/filtering/filtering.study-appendix-site";
import { CreateSeries_ActualDays, CreateSeries_EverDay } from "../../../../shared/scripts/graphing/graphing-functions";
import { ForecastGraphDataPoint } from "./forecasts.entities";
import { ForecastsLookup } from "./forecasts.lookup";
import { Study } from "../../../../shared/entities/scripts/study";
import { Appendix } from "../../../../shared/entities/scripts/appendix";
import { FormatNumberWithCommas } from "../../../../shared/scripts/number-functions";

var Highcharts = require('highcharts/highcharts');
require('highcharts/modules/lollipop')(Highcharts);
require('highcharts/highcharts-more')(Highcharts);
require('highcharts/modules/dumbbell')(Highcharts);
Highcharts.setOptions({
    lang: {
        thousandsSep: ','
    }
});

export class ForecastsPage implements IStudyAppendixSiteFilterParent {

    filter: StudyAppendixSiteFilterSection;

    msaAspirational: ForecastGraphDataPoint[];
    msaActual: ForecastGraphDataPoint[];
    //prescreeningAspirational: ForecastGraphDataPoint[];
    //prescreeningActual: ForecastGraphDataPoint[];
    addendumAspirational: ForecastGraphDataPoint[];
    addendumActual: ForecastGraphDataPoint[];
    activationAspirational: ForecastGraphDataPoint[]
    activationActual: ForecastGraphDataPoint[];
    randomizedAspirational: ForecastGraphDataPoint[];
    randomizedActual: ForecastGraphDataPoint[];
    irbSubmissionsAspirational: ForecastGraphDataPoint[];
    irbSubmissionsActual: ForecastGraphDataPoint[];

    siteActivationChart: any;
    randomizationChart: any;
    addendumChart: any;
    //prescreeningChart: any;
    irbSubmissionsChart: any;
    msaChart: any;

    constructor(MsaAspirationalJson: any, MsaActualJson: any, IrbSubmissionsAspirationalJson: any, IrbSubmissionsActualJson: any, SiteAddendumAspirationalJson: any, SiteAddendumActualJson: any, ActivationAspirationalJson: any, ActivationActualJson: any, RandomizedAspirationalJson: any, RandomizedActualJson: any, LastUpdatedJson: any) {

        $(() => {

            new DateUpdatedSection(LastUpdatedJson);

            //console.log("MsaAspirational", MsaAspirationalJson);console.log("MsaActual", MsaActualJson); console.log("PrescreeningAspirational", PrescreeningAspirationalJson); console.log("PrescreeningActual", PrescreeningActualJson); console.log("SiteAddendumAspirational", SiteAddendumAspirationalJson); console.log("SiteAddendumActual", SiteAddendumActualJson); console.log("SiteActivationAspirational", ActivationAspirationalJson); console.log("SiteActivationActual", ActivationActualJson); console.log("RandomizedAspirational", RandomizedAspirationalJson); console.log("RandomizedActual", RandomizedActualJson);
            //console.log(ActivationActualJson);

            this.msaAspirational = this.initializeGraphDataPoints(MsaAspirationalJson);
            this.msaActual = this.initializeGraphDataPoints(MsaActualJson);
            //this.prescreeningAspirational = this.initializeGraphDataPoints(PrescreeningAspirationalJson);
            //this.prescreeningActual = this.initializeGraphDataPoints(PrescreeningActualJson);
            this.addendumAspirational = this.initializeGraphDataPoints(SiteAddendumAspirationalJson);
            this.addendumActual = this.initializeGraphDataPoints(SiteAddendumActualJson);
            this.activationAspirational = this.initializeGraphDataPoints(ActivationAspirationalJson);
            this.activationActual = this.initializeGraphDataPoints(ActivationActualJson);
            //this.randomizedAspirational = this.initializeGraphDataPoints(RandomizedAspirationalJson).filter((x: ForecastGraphDataPoint) => !x.IsStudyWide); //only study-wide shown in forecasting for now
            this.randomizedAspirational = this.initializeGraphDataPoints(RandomizedAspirationalJson); 
            this.randomizedActual = this.initializeGraphDataPoints(RandomizedActualJson);
            this.irbSubmissionsAspirational = this.initializeGraphDataPoints(IrbSubmissionsAspirationalJson);
            this.irbSubmissionsActual = this.initializeGraphDataPoints(IrbSubmissionsActualJson);

            //console.log("MsaAspirational", this.msaAspirational); console.log("MsaActual", this.msaActual); console.log("SiteAddendumAspirational", this.addendumAspirational); console.log("SiteAddendumActual", this.addendumActual); console.log("SiteActivationAspirational", this.activationAspirational); console.log("SiteActivationActual", this.activationActual); console.log("RandomizedAspirational", this.randomizedAspirational); console.log("RandomizedActual", this.randomizedActual);
            //console.log("SiteActivationAspirational", this.activationAspirational); console.log("SiteActivationActual", this.activationActual);
            //console.log("SiteAddendumAspirational", this.addendumAspirational);
            //console.log("SiteActivationAspirational", this.activationAspirational);

            this.randomizationChart = this.initializeChart('randomization-forecast-chart', "Participants", this.createChartSeries('#152850', true));
            this.siteActivationChart = this.initializeChart('siteactivation-forecast-chart', "Sites", this.createChartSeries('#152850'));
            this.addendumChart = this.initializeChart('addendums-forecast-chart', "Contracts", this.createChartSeries('#152850'));
            //this.prescreeningChart = this.initializeChart('prescreening-forecast-chart', "Contracts", this.createChartSeries('#152850'));
            this.irbSubmissionsChart = this.initializeChart('irbsubmissions-forecast-chart', "IRB Submissions", this.createChartSeries('#152850'));
            this.msaChart = this.initializeChart('msa-forecast-chart', "Contracts", this.createChartSeries('#152850'));

            this.initializeFilter();

            $('#loading-indicator').hide();
            $('.loaded-content').removeClass('invisible');

            //this.triggerFilter();

            this.initiateZoomButtons();
         
        });

    }

    private initializeFilter(): void {
        let foundPrimeIds: number[] = [];
        let foundAppendixIds: number[] = [];
        let allPrimes: Study[] = [];
        let allAppendices: Appendix[] = [];

        //assumes site forecasts will be comprehensive. can always add a check for randomization forecast
        this.activationAspirational.forEach((x: ForecastGraphDataPoint) => {
            if (!foundPrimeIds.includes(x.PrimeId)) {
                allPrimes.push(new Study(x.PrimeId, Study.GetStudyName(x.PrimeId)));
                foundPrimeIds.push(x.PrimeId);
            }
            if (x.IsOverall == 0 && !foundAppendixIds.includes(x.AppendixId)) {
                allAppendices.push(new Appendix(x.AppendixId, x.PrimeId, Appendix.GetAppendixName(x.AppendixId)));
                foundAppendixIds.push(x.AppendixId);
            }
        });

        //console.log(allPrimes, allAppendices);

        this.filter = new StudyAppendixSiteFilterSection("#study-dropdown", "#appendix-dropdown", undefined, allPrimes, allAppendices, undefined, this);

        //InitializeFilterDropdown('#prime-contract-dropdown', ["AUTONOMIC", "ENERGIZE", "NEURO", "SLEEP", "VITAL", "Infrastructure"], this);

        //static as not based on filters
        this.msaChart.series[0].setData(CreateSeries_ActualDays(this.msaAspirational), true);
        this.msaChart.series[1].setData(CreateSeries_EverDay(this.msaActual), true);
        $('#msa-count-label').html(this.setCountLabel(this.msaChart.series[1].dataMax));


    }

    private initializeGraphDataPoints(json: any): ForecastGraphDataPoint[] {

        let output: ForecastGraphDataPoint[] = plainToClass(ForecastGraphDataPoint, <ForecastGraphDataPoint[]>json);
        output.map((point: ForecastGraphDataPoint) => {
            point.initialize();
            return point;
        });
        //output = output.sort((a, b) => a.getTimestamp() - b.getTimestamp());
        return output;
    }

    private initializeChart(id: string, yAxisLabel: string, series: any[] ): any {
        let chart: any = Highcharts.chart(id, {
            chart: {
                zoomType: 'x',
                resetZoomButton: {
                    position: {
                        align: 'center', // right by default
                        verticalAlign: 'bottom',
                        x: 0,
                        y: 0
                    },
                    relativeTo: 'chart'
                }
            },
            tooltip: {
                //xDateFormat: '%m/%d/%Y',
                xDateFormat: '%d%b%Y',
                shared: true,
                split: false,
                enabled: true,
                formatter: function (tooltip) {
                    //to make points appear in order in tooltip
                    this.points.reverse();
                    return tooltip.defaultFormatter.call(this, tooltip);
                },
            },
            title: {
                text: ''
            },
            credits: { enabled: false },
            plotOptions: {
                line: {
                    marker: { enabled: false }
                }
            },
            yAxis: {
                title: { text: yAxisLabel },
                labels: {
                    formatter: function () {
                        return Highcharts.numberFormat(this.value, 0, '', ',');
                    }
                }
            },
            xAxis: {
                type: 'datetime',
                crosshair: {
                    snap: true
                },
                labels: {
                    formatter: function () {
                        return Highcharts.dateFormat('%d%b%y', this.value);
                    }
                },
                events: {
                    afterSetExtremes: function (event) {
                        let resetZoomId = "#" + id + "-resetZoom";
                        if (event.max < event.dataMax || event.min > event.dataMin) {
                            $(resetZoomId).show();
                            
                        }
                        else {
                            $(resetZoomId).hide();
                        }
                    }
                }
            },
            legend: {
                enabled: true,
                reversed: true,
                margin: 10,
                align: 'center',
                verticalAlign: 'bottom',
                layout: 'horizontal',
                symbolHeight: 8,
                symbolWidth: 8,
                symbolRadius: 4,
                symbolPadding: 7
            },
            series: series
        });

        return chart;
    }

    private createChartSeries(color: string, isRandomizationChart: boolean = false): any[] {
        let series: any[] = [];
        if (isRandomizationChart) {
            //series.push({ id: 'Expected w/o site payments', name: 'Expected (w/o + Site Payments)', data: [], color: '#fdc757', type: 'scatter', marker: { radius: 4 } });
            series.push({ id: 'Expected w/o site payments', name: 'Expected (w/o + Site Payments)', data: [], color: '#fdc757', type: 'line', lineWidth: 0, marker: { enabled: true, radius: 5, symbol: 'triangle' }, states: { hover: { enabled: false } } });
        }
        series.push({ id: 'Expected', name: 'Expected', data: [], color: '#de4846', dashStyle: 'dot', type: 'lollipop', connectorWidth: 1, marker: { radius: 3, symbol: 'circle' } });
        series.push({ id: 'Actual', name: 'Actual', data: [], color: color, dashStyle: 'solid', step: 'left', type: 'line', marker: { lineWidth: '0', lineColor: color } });

        return series;
    }

    FilterUpdated(studyIds: number[], appendixIds: number[], siteIds: number[]) {
        //console.log("FilterUpdated", studyIds, appendixIds);

        //console.log(this.randomizedAspirational, this.randomizedActual);
        //console.log(this.activationAspirational, this.activationActual);
        //console.log(this.randomizedActual.filter((point: ForecastGraphDataPoint) => appendixIds.includes(point.AppendixId)));
        //console.log(CreateSeries_EverDay(this.randomizedActual.filter((point: ForecastGraphDataPoint) => appendixIds.includes(point.AppendixId))));
        //console.log(this.activationActual);

        this.randomizationChart.series[1].setData(CreateSeries_ActualDays(this.randomizedAspirational.filter((point: ForecastGraphDataPoint) => appendixIds.includes(point.AppendixId) && point.TypeId == 2 && point.IsOverall == 0)), true);
        this.randomizationChart.series[2].setData(CreateSeries_EverDay(this.randomizedActual.filter((point: ForecastGraphDataPoint) => appendixIds.includes(point.AppendixId))), true);

        //only show extra out-dated expected when only VITAL appendix is selected
        if ((studyIds.length == 1 && studyIds[0] == 2) || (appendixIds.length == 1 && appendixIds[0] == 1)) {
            this.randomizationChart.get('Expected w/o site payments').update({ visible: true, showInLegend: true });
            this.randomizationChart.series[0].setData(CreateSeries_ActualDays(this.randomizedAspirational.filter((point: ForecastGraphDataPoint) => appendixIds.includes(point.AppendixId) && point.TypeId == 4 && point.IsOverall == 0)), true);    
        }
        else {
            this.randomizationChart.get('Expected w/o site payments').update({ visible: false, showInLegend: false });
        }
        $('#randomization-count-label').html(this.setCountLabel(this.randomizationChart.series[2].dataMax));


        //if all appendices for a study are selected, use overall, otherwise use appendix-level
        let appendicesToShow: number[] = Appendix.GetAppendicesToShow(appendixIds);
        this.siteActivationChart.series[0].setData(CreateSeries_ActualDays(this.activationAspirational.filter((point: ForecastGraphDataPoint) => appendicesToShow.includes(point.AppendixId))), true);
        this.siteActivationChart.series[1].setData(CreateSeries_EverDay(this.activationActual.filter((point: ForecastGraphDataPoint) => DoArraysOverlap(appendicesToShow, point.AppendixIds))), true);
        $('#activated-sites-count-label').html(this.setCountLabel(this.siteActivationChart.series[1].dataMax));

        let studiesToShow: number[] = Study.GetStudiesToShow(appendixIds);

        // this isn't optimal
        // bug with the forecast not being cleared on filter change.
        // on filter change, reusing the series (like other charts) led to a "ghost" set of lollipops not being cleared (the intitial set)
        this.addendumChart.series[1].remove();
        this.addendumChart.series[0].remove();
        let newSeries: any[] = this.createChartSeries('#152850');
        this.addendumChart.addSeries(newSeries[0]);
        this.addendumChart.addSeries(newSeries[1]);
        this.addendumChart.series[0].setData(CreateSeries_ActualDays(this.addendumAspirational.filter((point: ForecastGraphDataPoint) => studiesToShow.includes(point.PrimeId))), false);
        this.addendumChart.series[1].setData(CreateSeries_EverDay(this.addendumActual.filter((point: ForecastGraphDataPoint) => studiesToShow.includes(point.PrimeId))), false);
        this.addendumChart.redraw();
        $('#addendums-count-label').html(this.setCountLabel(this.addendumChart.series[1].dataMax));

        this.irbSubmissionsChart.series[0].setData(CreateSeries_ActualDays(this.irbSubmissionsAspirational.filter((point: ForecastGraphDataPoint) => studiesToShow.includes(point.PrimeId))), true);
        this.irbSubmissionsChart.series[1].setData(CreateSeries_EverDay(this.irbSubmissionsActual.filter((point: ForecastGraphDataPoint) => studiesToShow.includes(point.PrimeId))), true);
        $('#irbsubmissions-count-label').html(this.setCountLabel(this.irbSubmissionsChart.series[1].dataMax));

    }

    private setCountLabel(amount: number): string {
        if (amount == undefined) return "0";
        else return FormatNumberWithCommas(amount + "");
    }

    private initiateZoomButtons() {
        $("#randomization-forecast-chart-resetZoom").hide();
        $("#siteactivation-forecast-chart-resetZoom").hide();
        $("#addendums-forecast-chart-resetZoom").hide();
        $("#irbsubmissions-forecast-chart-resetZoom").hide();
        //$("#prescreening-forecast-chart-resetZoom").hide();
        $("#msa-forecast-chart-resetZoom").hide();

        $("#randomization-forecast-chart-resetZoom").click(() => {
            this.randomizationChart.zoomOut();
        });

        $("#siteactivation-forecast-chart-resetZoom").click(() => {
            this.siteActivationChart.zoomOut();
        });

        $("#addendums-forecast-chart-resetZoom").click(() => {
            this.addendumChart.zoomOut();
        });

        //$("#prescreening-forecast-chart-resetZoom").click(() => {
        //    this.prescreeningChart.zoomOut();
        //})
        ;
        $("#irbsubmissions-forecast-chart-resetZoom").click(() => {
            this.irbSubmissionsChart.zoomOut();
        });

        $("#msa-forecast-chart-resetZoom").click(() => {
            this.msaChart.zoomOut();
        });
    }
}
